import { render, staticRenderFns } from "./NFTViewDetails.vue?vue&type=template&id=38bdf445&"
import script from "./NFTViewDetails.vue?vue&type=script&lang=ts&"
export * from "./NFTViewDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports